export default __webpack_public_path__ + "static/media/image-wps-3.f60c38a7.jpg";